import { dbObjectToId, filterDuplicates, md5, MissingDataException } from '@nu-art/ts-common';
import { ModuleFE_Referencable } from '../ModuleFE_Referencable.js';
import { Digraph, Edge, Node, Subgraph, toDot } from 'ts-graphviz';
const edgeTypeProperties = {
    inheritance: {},
};
const getNode = (id, label, className) => new Node(id, {
    id: id,
    label: label,
    shape: 'rect',
    style: 'filled',
    fillcolor: '#ffffff',
    fontsize: 13,
    fontcolor: '#333333',
    class: className
});
const getEdge = (originNode, targetNode, id, type) => new Edge([originNode, targetNode], { id, ...edgeTypeProperties[type] });
export const generateReferencablesGraphString = () => {
    const graph = new Digraph(undefined, {
        ranksep: 2,
        bgcolor: 'transparent',
    });
    const nodeMap = {};
    const inheritance = referencablesGraph_Inheritance(nodeMap);
    graph.addSubgraph(inheritance);
    return toDot(graph);
};
const referencablesGraph_Inheritance = (nodeMap) => {
    const subGraph = new Subgraph('inheritance');
    //The ref we start with is one that only extends itself, the OG referencable
    const entryRef = ModuleFE_Referencable.cache.find(ref => ref.extends.length === 1 && ref.extends[0] === ref._id);
    if (!entryRef)
        throw new MissingDataException('Missing Entry referencable');
    const resolveNode = (ref) => {
        const existing = nodeMap[ref._id];
        if (existing)
            return existing;
        const node = getNode(ref._id, ref.label);
        if (!ref.extends.length) {
            node.attributes.set('root', true);
            node.attributes.set('class', 'root');
        }
        subGraph.addNode(node);
        nodeMap[ref._id] = node;
        return node;
    };
    //Create Nodes
    let refs = [entryRef];
    while (refs.length) {
        const nextRefs = [];
        refs.forEach(ref => {
            const parentNode = resolveNode(ref);
            const children = ModuleFE_Referencable.cache.filter(child => child._id !== ref._id && child.extends.includes(ref._id));
            nextRefs.push(...children);
            children.forEach(child => {
                //Resolve node
                const childNode = resolveNode(child);
                //Connect inheritance edge
                const edge = getEdge(parentNode, childNode, md5(parentNode.id + childNode.id), 'inheritance');
                subGraph.addEdge(edge);
            });
        });
        refs = filterDuplicates(nextRefs, dbObjectToId);
    }
    return subGraph;
};
//# sourceMappingURL=utils.js.map